'use client';
import { Container, Paper } from '@mui/material';
import type { ReactNode } from 'react';
import FlashcardsBottomBar from '@/components/flashcard/flashcards-bottom-bar';
import BarBottom from '@/components/layout/bar-bottom';
import BarTop from '@/components/layout/bar-top';
import DrawerMenu from '@/components/layout/drawer-menu';
import Alerts from '@/components/shared/alerts';
import AnnouncementsModalManager from '@/components/shared/announcements-modal-manager';
import Dialog from '@/components/shared/dialog';
import LoadingIndicator from '@/components/shared/loading-indicator';
import { useAuth } from '@/providers';
import { useRoute } from '@/utils/client/route';

export default function AppLayout({
  children,
  container = true,
}: {
  children: ReactNode;
  container?: boolean;
}) {
  const { isSessionLoaded } = useAuth();
  const { isRoute } = useRoute();

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        minHeight: '100vh',
        '& > .MuiBox-root': {
          p: { md: 0 },
        },
      }}>
      <BarTop />
      {!isSessionLoaded ? (
        <LoadingIndicator label="Session wird geladen..." />
      ) : (
        <>
          <Alerts />
          {container ? <Container maxWidth="md">{children}</Container> : children}
          {isRoute('myCourseFlashcards') ? <FlashcardsBottomBar /> : <BarBottom />}
        </>
      )}
      <Dialog />
      <DrawerMenu />
      <AnnouncementsModalManager />
    </Paper>
  );
}
